import { Star } from "lucide-react";

interface Props { value: number; size?: string; onChange?: (v: number) => void; testId?: string }

export default function Stars({ value, size = "h-4 w-4", onChange, testId = "stars" }: Props) {
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testId} aria-label={`${value}/5`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(value);
        const cls = `${size} ${filled ? "fill-[#D4AF37] text-[#D4AF37]" : "text-slate-300"} ${onChange ? "cursor-pointer transition-transform hover:scale-110" : ""}`;
        return onChange
          ? <button key={n} type="button" onClick={() => onChange(n)} data-testid={`${testId}-${n}`} aria-label={`${n}`}><Star className={cls} /></button>
          : <Star key={n} className={cls} />;
      })}
    </span>
  );
}
